import vueFullcalendar from './fullCalendar'

const fc = vueFullcalendar

module.exports = fc


// WEBPACK FOOTER //
// ./src/topdoor/components/calendar/index.js